<template>
  <div class="px-6 lg:px-10 py-6">
    <h1 class="text-[26px] font-bold text-gray-900 mb-12">Income statement Report</h1>

    <div v-if="!canView" class="mt-10"></div>

    <DynamicReportForm
      v-else
      v-model="model"
      :fields="fields"
      :columns="1"
      stackAt="md"
      contentWidth="xl"
      actionLabel="View Report"
      :showTitle="false"
      @submit="onSubmit"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import DynamicReportForm from "@/components/DynamicReportForm.vue"
import { loadMyPermissions, hasAny } from "@/utils/permissions"

const router  = useRouter()
const canView = ref(false)

onMounted(async () => {
  await loadMyPermissions(false)
  canView.value = hasAny(["income_statement_report.view"])
})

const model = ref({
  company_id: "",
  from_date:  "",
  to_date:    "",
})

const fields = [
  {
    name:        "company_id",
    label:       "Select Company",
    type:        "select",
    span:        "full",
    placeholder: "Select company",
    loader: async () => ([
      { label: "Lyon Group",  value: 1 },
      { label: "Global Gate", value: 2 },
      { label: "Codexal",     value: 3 },
    ]),
  },
  { name: "from_date", label: "From", type: "date", span: 1, placeholder: "yyyy/mm/dd" },
  { name: "to_date",   label: "To",   type: "date", span: 1, placeholder: "yyyy/mm/dd" },
]

function onSubmit(payload) {
  router.push({
    name: "income-statement-view",
    query: {
      company_id: payload.company_id || "",
      from:       payload.from_date  || "",
      to:         payload.to_date    || "",
    },
  })
}
</script>
